/**
 * Утилиты для проверки ping к серверам
 */

/**
 * Симулирует ping к серверу (поскольку real ping невозможен в browser из-за CORS/HTTPS)
 * @param {string} ip - IP адрес сервера
 * @returns {Promise<number>} - Симулированный ping в миллисекундах
 */
export const pingServer = async (ip) => {
  try {
    // Поскольку real ping невозможен в браузере из-за CORS и Mixed Content Policy,
    // симулируем ping на основе IP-адреса (или можно использовать WebRTC/WebSocket решения)
    
    // Имитируем сетевую задержку
    await new Promise(resolve => setTimeout(resolve, Math.random() * 1000 + 500));
    
    // Генерируем реалистичный ping на основе IP (для демонстрации)
    const ipParts = ip.split('.');
    const lastOctet = parseInt(ipParts[ipParts.length - 1]) || 100;
    
    // Симулируем ping от 10ms до 200ms на основе последнего октета IP
    const basePing = 10 + (lastOctet % 190);
    const variation = Math.random() * 20 - 10; // ±10ms вариация
    const ping = Math.round(basePing + variation);
    
    return Math.max(10, ping); // Минимум 10ms
  } catch (error) {
    console.warn(`Ошибка ping к ${ip}:`, error);
    // Возвращаем случайный ping в случае ошибки
    return Math.round(Math.random() * 100 + 50);
  }
};

/**
 * Измеряет ping к нескольким серверам параллельно
 * @param {Array} servers - Массив серверов с полем ip
 * @returns {Promise<Array>} - Массив серверов с добавленным полем ping
 */
export const pingMultipleServers = async (servers) => {
  console.log('Симулируем ping для серверов:', servers.map(s => s.ip));
  
  const pingPromises = servers.map(async (server) => {
    const ping = await pingServer(server.ip);
    return {
      ...server,
      ping: `${ping}ms`
    };
  });
  
  return Promise.all(pingPromises);
};

/**
 * Форматирует название сервера из базы данных
 * Ожидает формат: "🇩🇪 Германия" -> { flag: "🇩🇪", country: "Германия" }
 * @param {string} serverName - Название сервера из базы данных
 * @returns {object} - Объект с флагом и названием страны
 */
export const parseServerName = (serverName) => {
  const parts = serverName.trim().split(' ');
  if (parts.length >= 2) {
    const flag = parts[0];
    const country = parts.slice(1).join(' ');
    return { flag, country };
  }
  
  // Если формат не соответствует ожидаемому, возвращаем как есть
  return { flag: '🌍', country: serverName };
}; 